import { createContext, ReactNode, useContext, useMemo } from 'react';

import { JabraTheme } from './JabraTheme.models';

export const JabraThemeContext = createContext<JabraTheme | undefined>(undefined);
export const useJabraTheme = () => {
  return useContext(JabraThemeContext);
};
export interface JabraThemeContextProps {
  theme: JabraTheme | undefined;
  children: ReactNode;
}

export const JabraThemeProvider = ({ theme, children }: JabraThemeContextProps) => {
  const { backgroundColor, foregroundColor, darkTheme } = theme ?? { darkTheme: true };
  const memoizedTheme = useMemo(() => {
    return { darkTheme, backgroundColor, foregroundColor };
  }, [darkTheme, backgroundColor, foregroundColor]);

  if (!theme) {
    return <>{children}</>;
  }

  return <JabraThemeContext.Provider value={memoizedTheme}>{children}</JabraThemeContext.Provider>;
};
